/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { AxiosError } from "axios"

import { TResponse } from "@pamf-my/types"

import requests from "@/services/requests"

interface Body {
  name: string
  agentEmail: string
  agentFirstname: string
  agentLastname: string
}

type OfficeCreateResponse = TResponse<undefined>

const SCreateOffice = async (body: Body) => {
  const token = localStorage.getItem("token")

  try {
    const { data } = await requests.post<OfficeCreateResponse>(
      "/office/create",
      body,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      }
    )
    return data
  } catch (error) {
    return (error as AxiosError).response?.data as OfficeCreateResponse
  }
}

export default SCreateOffice
